import React, { useMemo, useState } from "react";
import { Box, Typography, Button, Chip, Stack } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { theme } from "../../theme/colors";
import SocialLinksModal from "./SocialLinksModal";

const LEGACY_FIELDS = [
  { key: "website_url", title: "Website" },
  { key: "twitter_url", title: "Twitter/X" },
  { key: "instagram_url", title: "Instagram" },
  { key: "facebook_url", title: "Facebook" },
];

// Prefer the flexible social_links list; fall back to legacy URL fields so
// existing links still show before the backfill runs.
export function deriveSocialLinks(formData) {
  if (Array.isArray(formData?.social_links) && formData.social_links.length > 0) {
    return formData.social_links.filter((l) => l && l.url);
  }
  return LEGACY_FIELDS
    .filter((f) => formData?.[f.key])
    .map((f) => ({ title: f.title, url: formData[f.key] }));
}

export default function SocialLinksSection({ formData, onSocialLinksChange }) {
  const [modalOpen, setModalOpen] = useState(false);
  const links = useMemo(() => deriveSocialLinks(formData), [formData]);

  return (
    <Box id="social-links" sx={{ mb: 4, scrollMarginTop: "88px" }}>
      <Typography variant="h6" sx={{ fontWeight: 700, color: "#111", mb: 1 }}>
        Links
      </Typography>
      <Typography sx={{ fontSize: 14, color: "#334155", mb: 2 }}>
        Add up to 4 links to show on your public profile.
      </Typography>

      {links.length > 0 ? (
        <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", gap: 1, mb: 2 }}>
          {links.map((link, i) => (
            <Chip
              key={`${link.url}-${i}`}
              icon={<LinkIcon sx={{ fontSize: 16 }} />}
              label={link.title || link.url}
              sx={{
                maxWidth: 220,
                fontWeight: 600,
                color: "#0f172a",
                bgcolor: `${theme.primary}12`,
                "& .MuiChip-icon": { color: theme.primary },
              }}
            />
          ))}
        </Stack>
      ) : (
        <Typography sx={{ fontSize: 14, color: "#64748b", mb: 2 }}>
          No links added yet.
        </Typography>
      )}

      <Button
        onClick={() => setModalOpen(true)}
        variant="outlined"
        startIcon={<EditOutlinedIcon />}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          color: "#0f172a",
          borderColor: "#e2e8f0",
          borderRadius: 2,
          bgcolor: "#fff",
          "&:hover": { borderColor: theme.primary, color: theme.primary, bgcolor: "#f8fafc" },
        }}
      >
        Edit links
      </Button>

      <SocialLinksModal
        open={modalOpen}
        links={links}
        onClose={() => setModalOpen(false)}
        onSave={(next) => onSocialLinksChange(next)}
      />
    </Box>
  );
}
